import orderCustomFormImport from './orderCustomForm'
import orderCustomFormFieldsImport from './orderCustomFormFields'
import orderCustomFormLimitImport from './orderCustomFormLimit'
import orderCustomFormLinkManualImport from './orderCustomFormLinkManual'

export const orderCustomForm = orderCustomFormImport
export const orderCustomFormFields = orderCustomFormFieldsImport
export const orderCustomFormLimit = orderCustomFormLimitImport
export const orderCustomFormLinkManual = orderCustomFormLinkManualImport



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/getters/index.js